import React from 'react';
import classes from './swag-phone.scss';
export const SwagPhoneComponent = ({
  tenantCompanyPhone
}) => {
  if (!tenantCompanyPhone) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.outerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phoneWrapper
  }, /*#__PURE__*/React.createElement("a", {
    href: `tel:${tenantCompanyPhone}`,
    className: classes.phoneLink
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.icon
  }), /*#__PURE__*/React.createElement("p", {
    className: classes.number
  }, tenantCompanyPhone)), /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  })));
};